// ABOUTME: The grown-up-facing coaching strip for each step -- pure presentation, driven by
// ABOUTME: useSteersmanPreference's showSteersman flag (the header's SteersmanToggle owns the pill) (Issue #1940).

import { Box, Typography } from '@mui/material';
import { CROSSING_STEERSMAN_GROUND } from '../../../theme/crossingTokens';

interface SteersmanTip {
  screenId: string;
  text: string;
}

// Keyed by ScreenId, matching useCrossingContent()'s code-keyed lookup shape (Issue #1938).
type SteersmanTipsByKey = Record<string, SteersmanTip>;

interface SteersmanStripProps {
  screenId: string;
  tips: SteersmanTipsByKey;
  showSteersman: boolean;
}

export default function SteersmanStrip({ screenId, tips, showSteersman }: SteersmanStripProps) {
  const text = tips[screenId]?.text;

  if (!showSteersman || !text) {
    return null;
  }

  return (
    <Box data-testid="steersman-strip" sx={{ width: '100%', backgroundColor: CROSSING_STEERSMAN_GROUND, display: 'flex', alignItems: 'center', gap: 1, p: 1.5 }}>
      <Box component="img" data-testid="steersman-avatar" src="/nalu/paulele-64.png" alt="" sx={{ width: 20, height: 20 }} />
      <Box sx={{ flex: 1 }}>
        <Typography component="span" sx={{ fontSize: '9px', fontWeight: 800, letterSpacing: '0.05em' }}>
          STEERSMAN
        </Typography>
        <Typography data-testid="steersman-line" sx={{ fontStyle: 'italic' }}>
          {text}
        </Typography>
      </Box>
      <Typography variant="body2" sx={{ textAlign: 'right' }}>
        You can pause anytime — this Crossing will wait.
      </Typography>
    </Box>
  );
}
